import { Link } from 'react-router-dom';
import { SuperIcon } from '@shared/components/SuperIcon/SuperIcon';
import { useT } from '@shared/i18n/useT';
import {
  badgeStyle,
  bottomNavStyle,
  buildBottomItemStyle,
  buildNavItemStyle,
  navItemActiveBarStyle,
  railStyle,
  sectionLabelStyle,
} from './SuperSidebar.styles';
import type { SuperSidebarProps } from './SuperSidebar.types';
import { useSuperSidebar } from './useSuperSidebar';

export function SuperSidebar(props: SuperSidebarProps) {
  const { sections, activePath, brand, footer, mobileShortcuts, onMobileMore, className } = props;
  const { t } = useT('common');
  const vm = useSuperSidebar();

  if (vm.isMobile) {
    const shortcuts = mobileShortcuts ?? sections[0]?.items.slice(0, 4) ?? [];
    return (
      <nav aria-label="Mobile navigation" className={className} style={bottomNavStyle}>
        {shortcuts.map((item) => {
          const active = vm.resolveActive(item.to, activePath);
          return (
            <Link key={item.id} to={item.to} style={buildBottomItemStyle(active)}>
              <SuperIcon name={item.icon} size="md" />
              <span>{item.label}</span>
            </Link>
          );
        })}
        {onMobileMore && (
          <button type="button" onClick={onMobileMore} style={buildBottomItemStyle(false)}>
            <SuperIcon name="more-horizontal" size="md" />
            <span>{t('navMore')}</span>
          </button>
        )}
      </nav>
    );
  }

  return (
    <aside aria-label="Sidebar" className={className} style={railStyle}>
      {brand && <div style={{ marginBottom: 16, padding: '0 6px' }}>{brand}</div>}

      {sections.map((section) => (
        <div key={section.title}>
          <div style={sectionLabelStyle}>{section.title}</div>
          {section.items.map((item) => {
            const active = vm.resolveActive(item.to, activePath);
            return (
              <Link key={item.id} to={item.to} style={buildNavItemStyle(active)}>
                {active && <span aria-hidden style={navItemActiveBarStyle} />}
                <SuperIcon name={item.icon} size="md" />
                <span style={{ flex: 1 }}>{item.label}</span>
                {item.badge !== undefined && <span style={badgeStyle}>{item.badge}</span>}
              </Link>
            );
          })}
        </div>
      ))}

      {footer && <div style={{ marginTop: 'auto', padding: '0 6px' }}>{footer}</div>}
    </aside>
  );
}
